module.exports = __webpack_public_path__ + "img/img5.15fd242c.svg";